(function () {
	const debounce = (func, wait) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	};

	const animateHeadingDebounced = debounce(animateHeading, 100);

	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const isLoop = box.data("loop");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const slideSpeed = box.data("speed") * 1000;
			const slideCount = box.data("slide-count");
			const textEffects = box.data("text-effects");
			let parallaxEffect = false;
			let animationEffect = false;

			if (textEffects == "parallax") {
				parallaxEffect = true;
			}

			if (textEffects == "animation") {
				animationEffect = true;
			}

			let autoplayParam;
			if (autoplay && slideCount > 1) {
				autoplayParam = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParam = {
					autoplay: false,
				};
			}

			const commonParams = {
				speed: slideSpeed,
				effect: box.data("effect"),
				loop: isLoop && slideCount > 1,
				keyboard: true,
				...autoplayParam,
			};

			const swiperOverlayParams = {
				parallax: parallaxEffect,
				centeredSlides: false,
				creativeEffect: {
					prev: {
						translate: ["0%", "0%", 0],
					},
					next: {
						translate: ["0%", "0%", 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
			};

			const changeColorScheme = (context) => {
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				// NegoStore (perf 25.09.2026): cu un singur slide activeSlide lipseste si
				// linia de mai jos arunca TypeError la fiecare incarcare a paginii.
				if (!activeSlide) return;
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];

				const colorScheme = activeSlide.dataset.colorScheme;

				changeItems.forEach((item) => {
					if (item && item instanceof HTMLElement) {
						let classNames = item.getAttribute("class");
						classNames = classNames.replace(/color-background-\d+/g, "");
						item.setAttribute("class", classNames);
						item.classList.add(colorScheme);
					}
				});
			};

			const headings = document.querySelectorAll(
				`#${id} .slideshow-slide__content`
			);

			// NegoStore (perf 25.09.2026): gsap vine acum din slideshow.liquid, doar cu 'creative' si 2+ slide-uri.
			// Daca lipseste totusi, sarim peste animatia de tranzitie in loc sa aruncam eroare la schimbarea slide-ului.
			const hasGsap = () => typeof gsap !== "undefined";

			// NegoStore (perf 09.10.2026): imaginile slide-urilor 2+ vin din slideshow.liquid cu data-srcset /
			// data-src, ca sa nu concureze imaginea LCP. Le punem inapoi o singura data, la primul dintre:
			// load + idle (setTimeout 2 s unde nu exista requestIdleCallback), mouse / sageti / focus in hero,
			// prima glisare sau schimbare de slide (mai jos, dupa init) sau, cu autoplay, cu ~3 s inainte de prima tranzitie
			// (daca load-ul intarzie din cauza scripturilor terte). Se programeaza inainte de new Swiper, ca
			// imaginile sa revina chiar daca Swiper ar arunca.
			const sectionEl = this;
			let imagesRestored = !sectionEl.querySelector("[data-srcset], [data-src]");
			const restoreDeferredImages = () => {
				if (imagesRestored) return;
				imagesRestored = true;
				sectionEl.querySelectorAll("source[data-srcset]").forEach((source) => {
					source.srcset = source.dataset.srcset;
					source.removeAttribute("data-srcset");
				});
				sectionEl
					.querySelectorAll("img[data-srcset], img[data-src]")
					.forEach((img) => {
						if (img.dataset.srcset) img.srcset = img.dataset.srcset;
						if (img.dataset.src) img.src = img.dataset.src;
						img.removeAttribute("data-srcset");
						img.removeAttribute("data-src");
					});
			};

			if (!imagesRestored) {
				const restoreWhenIdle = () => {
					if (typeof window.requestIdleCallback === "function") {
						window.requestIdleCallback(restoreDeferredImages, { timeout: 2000 });
					} else {
						setTimeout(restoreDeferredImages, 2000);
					}
				};
				if (document.readyState === "complete") {
					restoreWhenIdle();
				} else {
					window.addEventListener("load", restoreWhenIdle, { once: true });
				}
				// NegoStore (perf 09.10.2026, review): pe telefon hero-ul tine mare parte din primul ecran, deci o
				// atingere oarecare pe el e de obicei inceputul unei derulari verticale si nu trebuie sa aduca
				// imaginile in fereastra LCP. Le aduc mouse-ul (desktop), sagetile si focusul; glisarea orizontala
				// e prinsa mai jos, prin sliderFirstMove.
				sectionEl.addEventListener(
					"pointerdown",
					(e) => {
						if (
							e.pointerType === "mouse" ||
							(e.target && e.target.closest && e.target.closest(".swiper-button"))
						) {
							restoreDeferredImages();
						}
					},
					{ passive: true }
				);
				sectionEl.addEventListener("focusin", restoreDeferredImages, { once: true });
				if (autoplay && slideCount > 1) {
					setTimeout(restoreDeferredImages, Math.max(delay - 3000, 1000));
				}
			}

			const swiperOverlay = new Swiper(`#${id} .slideshow__swiper`, {
				...commonParams,
				...swiperOverlayParams,
				on: {
					slidePrevTransitionStart: (e) => {
						if (animationEffect) {
							const activeIndex = swiperOverlay.realIndex;
							headings.forEach((item, index) => {
								if (index === activeIndex) {
									animateHeadingDebounced(item);
								}
							});
						}

						if (box.data("effect") == "creative" && hasGsap()) {
							let outgoingImg = $(`#${id} .slideshow-slide`).eq(
								e.previousIndex
							);

							gsap.fromTo(
								outgoingImg,
								{ x: "0%" },
								{ x: "10%", duration: 0.8, delay: 0, ease: "power3.InOut" }
							);

							let incomingImg = $(`#${id} .slideshow-slide`).eq(e.activeIndex);

							$(`#${id} .swiper-slide`).eq(e.activeIndex).css("z-index", "90");
							$(`#${id} .swiper-slide`)
								.eq(e.previousIndex)
								.css("z-index", "50");

							gsap.fromTo(
								incomingImg,
								{
									x: "-10%",
									clipPath: "polygon(0% 0%, -20% 0%, 0% 100%, 0% 100%)",
								},
								{
									x: "0%",
									clipPath: "polygon(0% 0%, 120% 0%, 100% 100%, 0% 100%)",
									duration: 0.95,
									ease: "power3.InOut",
								}
							);
						}
					},
					slideNextTransitionStart: (e) => {
						if (animationEffect) {
							const activeIndex = swiperOverlay.realIndex;
							headings.forEach((item, index) => {
								if (index === activeIndex) {
									animateHeadingDebounced(item);
								}
							});
						}
						if (box.data("effect") == "creative" && hasGsap()) {
							let outgoingImg = $(`#${id} .slideshow-slide`).eq(
								e.previousIndex
							);

							gsap.fromTo(
								outgoingImg,
								{ x: "0%" },
								{ x: "-10%", duration: 0.8, delay: 0, ease: "power3.InOut" }
							);

							let incomingImg = $(`#${id} .slideshow-slide`).eq(e.activeIndex);

							$(`#${id} .swiper-slide`).eq(e.activeIndex).css("z-index", "90");
							$(`#${id} .swiper-slide`)
								.eq(e.previousIndex)
								.css("z-index", "50");

							gsap.fromTo(
								incomingImg,
								{
									x: "10%",
									clipPath: "polygon(120% 0%, 100% 0%, 100% 100%, 100% 100%)",
								},
								{
									x: "0%",
									clipPath: "polygon(-20% 0%, 100% 0%, 100% 100%, 0% 100%)",
									duration: 0.95,
									ease: "power3.InOut",
								}
							);
						}
					},
					init: () => {
						if (animationEffect) {
							setTimeout(() => {
								animateHeadingDebounced(headings[0]);
							}, 0);
						}
						if (box.data("effect") == "creative") {
							$(`#${id} .slideshow`).addClass("start");
						}
					},
				},
			});

			// NegoStore (perf 09.10.2026): ascultatorii se pun dupa init. realIndexChange, nu slideChange: in modul
			// loop Swiper emite slideChange si la init si la orice redimensionare a hero-ului (slideToLoop pe acelasi
			// slide, de pilda cand apare sau dispare bara de derulare), deci ar aduce imaginile fara nicio schimbare
			// reala. sliderFirstMove = inceputul unei glisari orizontale (cea verticala nu-l emite).
			swiperOverlay.on("sliderFirstMove realIndexChange", restoreDeferredImages);

			// NegoStore (perf 09.10.2026): in Swiper 11 autoplay-ul tine o bucla requestAnimationFrame care merge
			// si pe pause(), deci ocupa firul principal tot timpul cat e pornit. Il oprim de tot (autoplay.stop())
			// cat hero-ul nu e in ecran sau cat un overlay e deschis peste pagina (nego:overlay:open, emis de
			// Cocktail Builder). Motivele se tin separat, ca sa nu se bata intre ele: pornim din nou
			// (autoplay.start(), ritmul de 9 + 1 s o ia de la capat) doar cand nu mai ramane niciun motiv si doar
			// daca noi l-am oprit.
			const autoplayModule = swiperOverlay.autoplay;
			if (
				autoplayModule &&
				swiperOverlay.params.autoplay &&
				swiperOverlay.params.autoplay.enabled
			) {
				const stopReasons = new Set();
				let stoppedByUs = false;
				const syncAutoplay = () => {
					if (swiperOverlay.destroyed || !sectionEl.isConnected) return;
					if (stopReasons.size) {
						if (autoplayModule.running) {
							autoplayModule.stop();
							stoppedByUs = true;
						}
					} else if (stoppedByUs) {
						stoppedByUs = false;
						if (!autoplayModule.running) autoplayModule.start();
					}
				};
				const setStopReason = (reason, active) => {
					if (active) {
						stopReasons.add(reason);
					} else {
						stopReasons.delete(reason);
					}
					syncAutoplay();
				};

				if ("IntersectionObserver" in window) {
					new IntersectionObserver((entries) => {
						const entry = entries[entries.length - 1];
						setStopReason("offscreen", !entry.isIntersecting);
					}).observe(box[0]);
				}

				document.addEventListener("nego:overlay:open", () => {
					setStopReason("overlay", true);
				});
				document.addEventListener("nego:overlay:close", () => {
					setStopReason("overlay", false);
				});

				// NegoStore (perf 09.10.2026, verificare): meniul lateral de pe telefon acopera hero-ul la fel ca builderul,
				// dar nu emite nego:overlay:open (aside-menu.js se inchide chiar la acest eveniment), deci autoplay-ul
				// mergea mai departe sub el. Ii urmarim clasa aside-menu--open. Builderul (bootOpen) si meniul
				// (data-nego-preopened) pot fi deschise si inainte de DOMContentLoaded, cand ascultatorii de aici nu
				// existau inca, asa ca le citim si starea de la init.
				const asideMenu = document.querySelector(".aside-menu");
				if (asideMenu && "MutationObserver" in window) {
					const syncMenuReason = () => {
						setStopReason("menu", asideMenu.classList.contains("aside-menu--open"));
					};
					new MutationObserver(syncMenuReason).observe(asideMenu, {
						attributes: true,
						attributeFilter: ["class"],
					});
					syncMenuReason();
				}
				if (document.querySelector('[id^="cb-overlay-"].cb-open')) {
					setStopReason("overlay", true);
				}
			}

			const slides = document.querySelectorAll(
				`#${id} .slideshow__swiper .swiper-slide`
			);

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (animationEffect) {
								const activeIndex = swiperOverlay.realIndex;
								headings.forEach((item, index) => {
									if (index === activeIndex) {
										animateHeadingDebounced(item);
									}
								});
							}
						}
					});
				},
				{ threshold: 0.5 }
			); 

			slides.forEach((slide) => observer.observe(slide));

			changeColorScheme(swiperOverlay);
			swiperOverlay.on("beforeTransitionStart", function () {
				changeColorScheme(this);
			});

			synchronizeWithTabs(swiperOverlay);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
